// extracted by mini-css-extract-plugin
export default {"icon":"Plus_icon__IMT+M"};